module.exports = "/_next/static/images/img__2-4923938a532abe105481a5640f63cb2a.png";